var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,8.34h7a9.66,9.66,0,0,1,9.52,8,10.71,10.71,0,0,1,.16,1.78c0,4.6,0,9.2,0,13.8a9.44,9.44,0,0,1-4.84,8.45A9.16,9.16,0,0,1,32,41.66q-7,0-14.05,0A9.7,9.7,0,0,1,8.32,32V17.86a9.67,9.67,0,0,1,9.51-9.52Zm0,2.58v0c-2.27,0-4.53,0-6.8,0a7.46,7.46,0,0,0-1.57.14,7,7,0,0,0-5.74,7.07q0,6.89,0,13.77a7.1,7.1,0,0,0,7.26,7.2H31.87a7.07,7.07,0,0,0,7.22-7.14c0-4.63,0-9.25,0-13.88a7,7,0,0,0-6.84-7.13C29.83,10.84,27.42,10.92,25,10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,16A9,9,0,1,1,16,25,9,9,0,0,1,25,16Zm0,2.61A6.38,6.38,0,1,0,31.37,25,6.3,6.3,0,0,0,25,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.56,15.4a1.95,1.95,0,1,1-1.94-2A2,2,0,0,1,36.56,15.4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/asset3.2363356f3272e64280e293df8d3ffa21.svg";
export { ForwardRef as ReactComponent };